import { render, staticRenderFns } from "./UserEditInsurance.vue?vue&type=template&id=60ba589b&"
import script from "./UserEditInsurance.vue?vue&type=script&lang=js&"
export * from "./UserEditInsurance.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/vhosts/dostartu.pl/app.startzone.online/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('60ba589b')) {
      api.createRecord('60ba589b', component.options)
    } else {
      api.reload('60ba589b', component.options)
    }
    module.hot.accept("./UserEditInsurance.vue?vue&type=template&id=60ba589b&", function () {
      api.rerender('60ba589b', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/UserEditInsurance.vue"
export default component.exports